var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { PureComponent } from "react";
import { defaultSeriesColor } from "../tokens.esm.js";
class Line extends PureComponent {
  render() {
    const {
      path,
      stroke,
      strokeWidth,
      fill,
      className
    } = this.props;
    return /* @__PURE__ */ jsx("path", { d: path, stroke: stroke || defaultSeriesColor, strokeWidth, fill, className });
  }
}
__publicField(Line, "propTypes", {
  className: PropTypes.string,
  fill: PropTypes.string,
  path: PropTypes.string.isRequired,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number
});
__publicField(Line, "defaultProps", {
  strokeWidth: 1.5,
  fill: "none",
  className: "rd3-linechart-path"
});
export {
  Line as default
};
